<template>
  <div class="acquirer">
    <!-- <h1>acquirer</h1> -->
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters class="mt-2">
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet>
          <v-breadcrumbs
            :items="[{ text: $t('surcharge'), disabled: true, href: '/' }]"
          ></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet>
          <!-- <v-btn class="text-none text-subtitle-1" color="#5865f2" size="small" variant="flat" >Add Acquirer</v-btn>             -->
          <!-- <v-btn density="compact">Add Acquirer</v-btn>  -->
          <v-btn
            class="button_size"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_MOD_OTHERS')              
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            {{ $t("new_surcharge") }}
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="search_row">
      <v-col cols="3">
        <v-text-field
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          :label="$t('search')"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchSurcharge"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-card v-else>
      <v-data-table
        :headers="headers"
        :items="surcharge"
        class="elevation-1 custom-table-style"
        :items-per-page="itemsPerPage"
        :items-length="totalItems"
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
      >
        <!-- <template v-slot:item.acquirers="{ item }">
          <td>
            <tr v-for="it in item.raw.acquirers" :key="it.id">
              <td>{{ it.acquirerName }}</td>
            </tr>
          </td>
        </template> -->

        <!-- FOR EXPANSION -->
        <template v-slot:expanded-row="{ columns, item }">
          <!-- <tr>
                        <td :colspan="columns.length">               
                          More info about {{ item.value.deviceId }}
                        </td>
                      </tr> -->
          <tr>
            <td>{{ $t("acquirer") }}</td>
            <td :colspan="columns.length" style="padding: 10px">
              <tr v-for="it in item.raw.acquirers" :key="it.id">
                <td>{{ it.acquirerName }}</td>
              </tr>
            </td>
          </tr>
        </template>

        <template v-slot:item.actions="{ item }">
          <!-- <v-icon color="green" small class="mr-2" @click="compose_update(item.value.acquirerId)" v-if="this.user_permissions.includes('Edit acquirer') || this.user_permissions.includes('All') ">mdi-pencil</v-icon>
              <v-icon color="red" small @click="compose_delete(item.value.acquirerId)" v-if="this.user_permissions.includes('Delete acquirer') || this.user_permissions.includes('All') ">mdi-delete</v-icon> -->
          <v-tooltip :text="$t('Update')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                color="green"
                small
                class="mr-2"
                @click="compose_update(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_MOD_OTHERS')                  
                "
                >mdi-pencil-circle</v-icon
              >
            </template>
          </v-tooltip>
          <v-tooltip :text="$t('Delete')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                color="red"
                small
                @click="compose_delete(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_DEL_OTHERS') ||
                  this.global_permissions.includes('ROLE_STAFF_ADMIN')
                "
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
        </template>
        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              total-visible="7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- ADD SURCHARGE DIALOG -->
    <v-dialog v-model="dialog" persistent width="1200">
      <v-card>
        <v-form ref="addSurcharge" v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("new_surcharge") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('surcharge_name')"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="surcharge_data.f_surchargeName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('discount_lower_bin')"
                      :readonly="loading"
                      :rules="[required, validateBin]"
                      clearable
                      v-model="surcharge_data.f_lowerBin"
                      maxlength="12"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('discount_higher_bin')"
                      :readonly="loading"
                      :rules="[required, validateBin]"
                      clearable
                      v-model="surcharge_data.f_higherBin"
                      maxlength="12"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('surcharge%')"
                      :readonly="loading"
                      :rules="[required, validateSurcharge]"
                      clearable
                      v-model="surcharge_data.f_surcharge"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-select
                      :items="['true', 'false']"
                      :label="$t('discount_status')"
                      v-model="surcharge_data.f_status"
                      :rules="[required]"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <!-- <v-autocomplete
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      :label="$t('select_acquirers')"
                      multiple
                      :rules="[required]"
                      v-model="surcharge_data.f_acquirerList"
                    ></v-autocomplete> -->

                    <v-select
                      v-model="surcharge_data.f_acquirerList"
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                    >
                      <template v-slot:prepend-item>
                        <v-list-item title="Select All" @click="toggle">
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :color="likesSome ? 'indigo-darken-4' : undefined"
                              :indeterminate="likesSome && !likesAll"
                              :model-value="likesAll"
                            ></v-checkbox-btn>
                          </template>
                        </v-list-item>

                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">
                {{ $t("Close") }}
              </v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addSurcharge"
              >
                {{ $t("Save") }}
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD SURCHARGE DIALOG -->

    <!-- UPDATE SURCHARGE DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="1200">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5"> {{ $t("update_surcharge") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('surcharge_name')"
                      :readonly="loading"
                      :rules="[required, validateName]"
                      clearable
                      v-model="surcharge_data.f_surchargeName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('discount_lower_bin')"
                      :readonly="loading"
                      :rules="[required, validateBin]"
                      maxlength="12"
                      clearable
                      v-model="surcharge_data.f_lowerBin"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('discount_higher_bin')"
                      :readonly="loading"
                      :rules="[required, validateBin]"
                      maxlength="12"
                      clearable
                      v-model="surcharge_data.f_higherBin"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('surcharge%')"
                      :readonly="loading"
                      :rules="[required, validateSurcharge]"
                      clearable
                      v-model="surcharge_data.f_surcharge"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-select
                      :items="['true', 'false']"
                      :label="$t('discount_status')"
                      v-model="surcharge_data.f_status"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <!-- <v-autocomplete
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      :label="$t('select_acquirers')"
                      multiple
                      :rules="[required]"
                      v-model="surcharge_data.f_acquirerList"
                    ></v-autocomplete> -->
                    <v-select
                      v-model="surcharge_data.f_acquirerList"
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      label="Select Acquirers"
                      multiple
                    >
                      <template v-slot:prepend-item>
                        <v-list-item title="Select All" @click="toggle">
                          <template v-slot:prepend>
                            <v-checkbox-btn
                              :color="likesSome ? 'indigo-darken-4' : undefined"
                              :indeterminate="likesSome && !likesAll"
                              :model-value="likesAll"
                            ></v-checkbox-btn>
                          </template>
                        </v-list-item>

                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue-darken-1"
                variant="text"
                @click="dialog_update = false"
              >
                {{ $t("Close") }}
              </v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateSurcharge"
              >
                {{ $t("Update") }}
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE SURCHARGE DIALOG -->

    <!-- DELETE SURCHARGE DIALOG -->
    <!-- <v-dialog
              v-model="dialog_delete"
              persistent
              width="500"
            >              
              <v-card>
                <v-card-title>
                  <div class="container">
                  <span class="text-h5">{{ $t('Do you want to delete') }} ?</span></div>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                                           
                    </v-row>
                  </v-container>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="dialog_delete = false"
                  >
                    {{ $t('Close') }}
                  </v-btn>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="deleteSurcharge"
                  >
                    {{ $t('Delete') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">{{ $t("deleteFile") }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t("deleteText") }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteSurcharge">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END DELETE SURCHARGE DIALOG -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Surcharge",
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      emits: ["reload"],
      acquirers: [],
      surcharge: [],
      organization: [],
      dialog: false,
      dialog_update: false,
      dialog_delete: false,

      surcharge_data: {
        f_surchargeName: "",
        f_lowerBin: "",
        f_higherBin: "",
        f_surcharge: "",
        f_status: "",
        f_acquirerList: [],
        f_orgId: "",
      },

      surchargeId: "",
      search: "",
      headers: [
        {
          title: this.$t("surcharge_name"),
          align: "start",
          sortable: false,
          key: "surchargeName",
        },
        // { title: "Bin", key: "bin" },
        { title: "", key: "data-table-expand" },
        { title: this.$t("discount_lower_bin"), key: "lowerBin" },
        { title: this.$t("discount_higher_bin"), key: "higherBin" },
        { title: this.$t("surcharge%"), key: "surcharge" },
        // { title: this.$t("acquirer"), key: "acquirers", sortable: true },
        {
          title: this.$t("Organization"),
          key: "organization.orgName",
          sortable: true,
        },
        {
          title: this.$t("Actions"),
          key: "actions",
          sortable: false,
          width: "100px",
        },
      ],

      //form
      form: false,
      loading: true,
      email_exist: false,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
    };
  },

  computed: {
    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      let count = Math.ceil(this.totalItems / this.itemsPerPage);

      return count;
    },

    //for select all acquirers
    likesAll() {
      //return this.selectedFruits.length === this.fruits.length
      return (
        this.surcharge_data.f_acquirerList.length === this.acquirers.length
      );
    },
    likesSome() {
      //return this.selectedFruits.length > 0
      return this.surcharge_data.f_acquirerList.length > 0;
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },
  },

  created() {},

  methods: {
    onSubmit() {
      if (!this.form) return;
    },

    resetData() {
      this.fetchData();
    },

    //for select all acquirers
    toggle() {
      if (this.likesAll) {
        this.surcharge_data.f_acquirerList = [];
      } else {
        //this.aid_data.f_acquirerList = this.acquirers.slice()
        let i = 0;
        this.surcharge_data.f_acquirerList = [];
        for (i = 0; i < this.acquirers.length; i++) {
          this.surcharge_data.f_acquirerList.push(this.acquirers[i].id);
        }
      }
    },

    resetInput() {
      this.surcharge_data.f_surchargeName = "";
      this.surcharge_data.f_lowerBin = "";
      this.surcharge_data.f_higherBin = "";
      this.surcharge_data.f_surcharge = "";
      this.surcharge_data.f_status = "";
      this.surcharge_data.f_acquirerList = [];
      this.surcharge_data.f_orgId = "";
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.checkTokenExpiry();
      this.requests_handler();
    },

    compose_update(id) {
      this.surchargeId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.surchargeId = id;
      this.dialog_delete = true;
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    requests_handler() {
      axios
        .all([
          //axios.get(window.baseurl+"org/get/"+this.orgId , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} }),
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((acquirer_response) => {
            // console.log("data2", acquirer_response);

            //if response data is an array // handle it as below
            if (acquirer_response.status == 200) {
              if (
                acquirer_response.data.records != null &&
                acquirer_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirers = []; //remove all items from array
                for (i = 0; i < acquirer_response.data.records.length; i++) {
                  this.acquirers.push({
                    id: acquirer_response.data.records[i].id,
                    name: acquirer_response.data.records[i].acquirerName,
                  });
                  //console.log("acquirers", this.acquirers)
                }
              }
            }
            //if response data is a single object // handle it as below
            /* if(second_response.status == 200){  
                  this.organization = [];  //remove all items from array
                  this.organization.push(second_response.data);                          
                  console.log("organization1", this.organization)
                  
              } */
          })
        );
    }, //end of requests_handler method

    async addSurcharge() {
      //this.dialog = false
      //console.log("form data", this.surcharge_data);
      this.checkTokenExpiry();
      try {
        let result = await axios.post(
          window.baseurl + "surcharges",
          {
            surchargeName: this.surcharge_data.f_surchargeName,
            lowerBin: this.surcharge_data.f_lowerBin,
            higherBin: this.surcharge_data.f_higherBin,
            surcharge: this.surcharge_data.f_surcharge,
            status: this.surcharge_data.f_status,
            //orgId:this.surcharge_data.f_orgId,
            organization_id: this.orgId,
            acquirersList: this.surcharge_data.f_acquirerList,
            createdBy: this.userEmail,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.warn("result", result);
        if (result.status == 201) {
          //alert("log in successfull");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("surcharge_created") });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "surcharges/" + this.surchargeId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          //axios.get(window.baseurl+"org/get/"+this.orgId , {"headers": {'Authorization': 'Bearer ' + this.$cookies.get('accessToken')} }),
          axios.get(window.baseurl + "acquirers/org/" + this.orgId, {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((surcharge_response, acquirer_response) => {
            // console.log("data1", surcharge_response.data);
            // console.log("data2", acquirer_response.data);

            //get discount data for selected id and display data in for dialog
            if (surcharge_response.status == 200) {
              // console.log("surcharge Data", this.surcharge_response);
              this.surcharge_data.f_surchargeName =
                surcharge_response.data.surchargeName;
              this.surcharge_data.f_lowerBin = surcharge_response.data.lowerBin;
              this.surcharge_data.f_higherBin =
                surcharge_response.data.higherBin;
              this.surcharge_data.f_surcharge =
                surcharge_response.data.surcharge;
              this.surcharge_data.f_status = surcharge_response.data.status;
              //this.surcharge_data.f_orgId = surcharge_response.data.organization.orgId
              //this.surcharge_data.f_acquirerList = surcharge_response.data.acquirers  //this appoch does not work here . compare it imlementation in Role.vue

              let i = 0;
              this.surcharge_data.f_acquirerList = [];
              for (i = 0; i < surcharge_response.data.acquirers.length; i++) {
                this.surcharge_data.f_acquirerList.push(
                  surcharge_response.data.acquirers[i].id
                );
              }
            }

            if (acquirer_response.status == 200) {
              if (
                acquirer_response.data.records != null &&
                acquirer_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirers = []; //remove all items from array
                for (i = 0; i < acquirer_response.data.records.length; i++) {
                  this.acquirers.push({
                    id: acquirer_response.data.records[i].id,
                    name: acquirer_response.data.records[i].acquirerName,
                  });
                  //console.log("acquirers", this.acquirers)
                }
              }
            }

            //if response data is a single object // handle it as below
            /* if(second_response.status == 200){  
                  this.organization = [];  //remove all items from array
                  this.organization.push(second_response.data);                          
                  console.log("organization1", this.organization)
                  
              } */
          })
        );
    }, //end of requests_handler 2 method

    async updateSurcharge() {
      this.dialog_update = false;
      this.checkTokenExpiry();
      try {
        // console.log("update form surcharge id", this.surchargeId);
        // console.log("update form surcharge", this.surcharge_data);
        let result = await axios.put(
          window.baseurl + "surcharges/" + this.surchargeId,
          {
            surchargeName: this.surcharge_data.f_surchargeName,
            lowerBin: this.surcharge_data.f_lowerBin,
            higherBin: this.surcharge_data.f_higherBin,
            surcharge: this.surcharge_data.f_surcharge,
            status: this.surcharge_data.f_status,
            //orgId:this.surcharge_data.f_orgId,
            organization_id: this.orgId,
            acquirersList: this.surcharge_data.f_acquirerList,
            updatedBy: this.userEmail,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        // console.log("update form surcharge result", result);
        if (result.status == 200) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("surcharge_updated") });
          window.setInterval(() => {
            this.dialog_update = false;
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if (error.response.status == 417) {
          this.$root.vtoast.showError({ message: error.response.data.message });
        } else if (error.response.status == 500) {
          this.$root.vtoast.showError({ message: error.response.data.detail });
        } else {
          this.$root.vtoast.showError({ message: error.response.data.message });
        }
      }
    },

    async deleteSurcharge() {
      this.dialog_delete = false;
      this.checkTokenExpiry();
      try {
        let result = await axios.delete(
          window.baseurl + "surcharges/" + this.surchargeId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );

        if (result.status == 204) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Deleted");
          // this.$root.vtoast.show({message: result.data.message});
          this.$root.vtoast.show({ message: this.$t("surcharge_deleted") });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
      }
    },

    async fetchData() {
      let result;
      let page2 = this.page - 1;
      this.loading = true;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "surcharges", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("discount_object", result);
          this.surcharge = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_MOD_OTHERS")          
        ) {
          result = await axios.get(
            window.baseurl + "surcharges/org/" + this.orgId,
            {
              params: { page: page2 },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("discount_object", result);
          this.surcharge = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    async searchSurcharge() {
      let result;
      let page2 = this.page - 1; //pagination starts from 1 in vue , in spring boot pgae start from zero
      this.loading = true;
      this.checkTokenExpiry();
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "surcharges/search", {
            //params: { page: page2 , pagesize: 100, search: this.query },
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("search_discount_object", result);
          this.surcharge = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        } else if (
          this.global_permissions.includes("ROLE_MOD_OTHERS")          
        ) {
          result = await axios.get(
            window.baseurl + "surcharges/org/search/" + this.orgId,
            {
              params: { page: page2, search: this.query },
              headers: { Authorization: "Bearer " + this.accessToken },
            }
          );

          // console.log("search_discount_object", result);
          this.surcharge = result.data.records;
          this.totalItems = result.data.totalRecords;
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    /* VALIDATION RULES */

    validateName(value) {
      const regex = /^[A-Za-z0-9_ ]+$/;
      return (
        regex.test(value) ||
        "Name can only contain letters, numbers, and underscores."
      );
    },

    validateSurcharge(value) {
      const regex = /^[0-9]{1,2}([.][0-9]{1,2})?$/;
      return (
        regex.test(value) ||
        "Surcharge takes a whole numbers (1-99) or a decimal value (00.00)."
      );
    },
    validateBin(value) {
      if (value.length === 12) {
        return true;
      } else {
        return "Bin should be 12 digits";
      }
    },
    required(v) {
      return !!v || "Field is required";
    },
  },

  //get list of surcharge
  async mounted() {
    this.checkTokenExpiry();

    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
